var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notification-strategy-config" },
    [
      _c(
        "div",
        { staticClass: "action-btn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", icon: "el-icon-plus" },
              on: { click: _vm.addStrategy },
            },
            [_vm._v(" " + _vm._s(_vm.$t("basicData.AddRow")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.strategyList, border: "", "max-height": "350" } },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.NotificationDimension"),
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function () {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("basicData.RemainingAvailableAmount"))
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.Condition"),
              width: "120",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function () {
                  return [_c("span", [_vm._v("<")])]
                },
                proxy: true,
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("span", [
                      _c("span", { staticStyle: { color: "#f56c6c" } }, [
                        _vm._v("*"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("basicData.Value")) + " "),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        precision: 2,
                        step: 1,
                        min: 0,
                        controls: false,
                        size: "mini",
                        placeholder: _vm.$t("basicData.PleaseEnter"),
                      },
                      model: {
                        value: row.thresholdAmount,
                        callback: function ($$v) {
                          _vm.$set(row, "thresholdAmount", $$v)
                        },
                        expression: "row.thresholdAmount",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.operate"),
              width: "120",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var $index = ref.$index
                  return [
                    _c(
                      "el-popconfirm",
                      {
                        attrs: { title: _vm.$t("basicData.AreYouSureDelete") },
                        on: {
                          confirm: function ($event) {
                            return _vm.deleteStrategy(row, $index)
                          },
                        },
                      },
                      [
                        _c(
                          "template",
                          { slot: "reference" },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "danger", size: "mini" } },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("basicData.Delete")) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "operate-button" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: { margin: "0" },
              attrs: { size: "small", type: "primary", loading: _vm.saving },
              on: { click: _vm.save },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.Save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }